import { useEffect, useState } from 'react';
import { Modal as AntModal, Pagination } from 'antd'
import { ChevronLeft, Users, Lock, MapPin, Camera, Search, Trash2, Mail, Plus, Clock, PencilIcon, CameraIcon, Video } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom'
import { useGetLocationQuery, useLocationCameraListQuery, useAddNewLocationCamera, useDeleteLocationCamera, useLocationInviationListQuery, useAddNewLocationInvitation, useCancelLocationInvitation, useAddNewLocationInvitationBulk, useEditLocationCamera, useCameraRecordingListQuery } from "../../../hooks/useLocations"
import { themeStore } from '../../../stores/theme';
import { useStore } from '@tanstack/react-store';
import { noData } from '../../ui/media';
import { useQueryClient } from '@tanstack/react-query';
import { useSingleSubmit } from '../../../hooks/useSingleSubmit';
import DatePicker from 'react-datepicker';
import Modal from '../../common/ModalComponent';
import toast from 'react-hot-toast';
import SingleSubmitForm from '../../common/SingleSubmitForm';
import eventIcon from "../../../assets/icons/calendar.png"
import HLSPlayer from "../../../components/common/HLSPlayer"
import moment from 'moment/moment';

const LocationDetails = () => {
    const { isDarkMode } = useStore(themeStore)
    const [activeTab, setActiveTab] = useState('Invited Tenant');
    const [searchCameraTerm, setSearchCameraTerm] = useState('');
    const [searchInviteTerm, setSearchInviteTerm] = useState('');
    const [searchRecordingTagTerms, setSearchRecordingTagTerms] = useState('');
    const { REACT_APP_IMAGE_URL, REACT_APP_STEAM_DISTRIBUTION, REACT_APP_EXCEL_FORMAT_LINK } = process.env
    const { _id } = useParams()
    const { canSubmit, resetSubmit } = useSingleSubmit();
    const { data: locationResponse, isSuccess: isLocationSuccess } = useGetLocationQuery(`?location_id=${_id}`, 'location')
    const [locationData, setLocationData] = useState(null)
    const [connectedCameras, setConnectedCameras] = useState([])
    const [invitedTenants, setInvitedTenants] = useState([])
    const [showPlayStreamModal, setShowPlayStreamModal] = useState(false)
    const [playbackStreamURL, setPlaybackStreamURL] = useState(null)
    const [locationCamName, setLocationCamName] = useState("")
    const [locationCamUrl, setLocationCamUrl] = useState("")
    const [locationTenantName, setLocationTenantName] = useState("")
    const [locationTenantEmail, setLocationTenantEmail] = useState("")
    const [bulkInviteFile, setBulkInviteFile] = useState(null)
    const [selectedCamRecordings, setSelectedCamRecordings] = useState([])
    const [showLocationAddCamModal, setShowLocationAddCamModal] = useState(false);
    const [showLocationEditCamModal, setShowLocationEditCamModal] = useState(false);
    const [recordingDate, setRecordingDate] = useState(moment().toLocaleString());
    const [showDeleteCamModal, setShowDeleteCamModal] = useState(false);
    const [showLocationSendInviteModal, setShowLocationSendInviteModal] = useState(false);
    const [showCancelInviteModal, setShowCancelInviteModal] = useState(false);
    const [isRecordingCamSelected, setIsRecordingCamSelected] = useState('');
    const [showLocationSendBulkInviteModal, setShowLocationSendBulkInviteModal] = useState(false);
    const [currentLocationCam, setCurrentLocationCam] = useState(null);
    const [currentLocationInvitation, setCurrentLocationInvitation] = useState(null);
    const addNewLocationCamMutation = useAddNewLocationCamera()
    const editLocationCamMutation = useEditLocationCamera()
    const deleteLocationCamMutation = useDeleteLocationCamera()
    const addNewLocationInvitationMutation = useAddNewLocationInvitation()
    const cancelLocationInvitationMutation = useCancelLocationInvitation()
    const addNewLocationBulkInvitationMutation = useAddNewLocationInvitationBulk()
    const navigate = useNavigate()
    const queryClient = useQueryClient();
    const [recordingPage, setRecordingPage] = useState(1);
    const [recordingLimit, setRecordingLimit] = useState(10);
    const [recordingTotalPages, setRecordingTotalPages] = useState(0);

    const { data: connectedCamerasResponse, isSuccess: isconnectedCamerasSuccess } = useLocationCameraListQuery(
        (activeTab === 'Connected Cameras' || activeTab === 'Streams' || activeTab == "Recordings") ?
            `?location_id=${_id}`
            : null,
        {
            enabled: !!activeTab
        }
    );

    const { data: invitationResponse, isSuccess: isInvitationSuccess } = useLocationInviationListQuery(
        activeTab === 'Invited Tenant' ?
            `?location_id=${_id}`
            : null,
        {
            enabled: !!activeTab
        }
    );

    const { data: cameraRecordingResponse, isSuccess: isCameraRecordingResponse } = useCameraRecordingListQuery(
        (isRecordingCamSelected && recordingDate) ?
            `?cam_id=${isRecordingCamSelected?._id}&date=${moment(recordingDate).format("DD-MM-yyyy")}&search_key=${searchRecordingTagTerms}&page=${recordingPage}&limit=${recordingLimit}`
            : null,
        {
            enabled: !!activeTab
        }
    );

    useEffect(() => {
        if (isCameraRecordingResponse) {
            setSelectedCamRecordings(cameraRecordingResponse?.data?.data?.result ?? [])
            setRecordingTotalPages(cameraRecordingResponse?.data?.data?.totalCount)
        }
    }, [cameraRecordingResponse, isCameraRecordingResponse])

    const colors = {
        text: isDarkMode ? '#e0e0e0' : '#333333',
        border: isDarkMode ? '#333333' : '#e0e0e0',
        inputBackground: isDarkMode ? '#2d2d2d' : '#ffffff'
    };

    const resetStates = () => {
        setLocationCamName("")
        setLocationCamUrl("")
        setLocationTenantName("")
        setLocationTenantEmail("")
    }

    const handleLocationAddCam = () => {
        if (locationCamName === "") {
            toast.error("Camera Name is not allowed to empty")
            return
        }
        if (locationCamUrl === "") {
            toast.error("URL is not allowed to empty")
            return
        }
        const inputData = {
            url: locationCamUrl,
            name: locationCamName,
            location_id: _id
        }
        addNewLocationCamMutation.mutate(inputData, {
            onSuccess: () => {
                resetStates();
                setShowLocationAddCamModal(false)
                toast.success("New Camera Added Successfully")
                queryClient.invalidateQueries({ queryKey: ['camera_list'] });
            },
            onError: (err) => {
                console.log("error", err)
                const message = err.response?.data?.message || "Add New Location Camera Action Failed"
                toast.error(message)
            }
        })
    }

    const handleLocationEditCam = () => {
        if (locationCamName === "") {
            toast.error("Camera Name is not allowed to empty")
            return
        }
        if (locationCamUrl === "") {
            toast.error("URL is not allowed to empty")
            return
        }
        const inputData = {
            url: locationCamUrl,
            name: locationCamName,
            location_id: _id,
            camera_id: currentLocationCam?._id
        }
        editLocationCamMutation.mutate(inputData, {
            onSuccess: () => {
                resetStates();
                setShowLocationEditCamModal(false)
                toast.success("Camera Updated Successfully")
                queryClient.invalidateQueries({ queryKey: ['camera_list'] });
            },
            onError: (err) => {
                console.log("error", err)
                const message = err.response?.data?.message || "Update Location Camera Action Failed"
                toast.error(message)
            }
        })
    }

    const confirmDeleteCamera = () => {
        deleteLocationCamMutation.mutate({ camera_id: currentLocationCam._id }, {
            onSuccess: () => {
                toast.success("Camera deleted successfully");
                queryClient.invalidateQueries(['camera_list']); // Adjust key if needed
            },
            onError: (err) => {
                const message = err.response?.data?.message || "Failed to delete camera";
                toast.error(message);
            },
        });
        setShowDeleteCamModal(false);
    }

    const handleDeleteCamera = (camera) => {
        setCurrentLocationCam(camera);
        setShowDeleteCamModal(true);
    };

    const handleEditCamera = (camera) => {
        setLocationCamName(camera?.name)
        setLocationCamUrl(camera?.url)
        setCurrentLocationCam(camera);
        setShowLocationEditCamModal(true);
    };

    // invitation Methods
    const handleLocationSendInvite = () => {
        if (locationTenantName === "") {
            toast.error("Name is not allowed to empty")
            return
        }
        if (locationTenantEmail === "") {
            toast.error("Email is not allowed to empty")
            return
        }
        const inputData = {
            email: locationTenantEmail,
            name: locationTenantName,
            location_id: _id
        }
        addNewLocationInvitationMutation.mutate(inputData, {
            onSuccess: () => {
                resetStates();
                setShowLocationSendInviteModal(false)
                toast.success("Inviation Sent Successfully")
                queryClient.invalidateQueries({ queryKey: ['invitation_list'] });
            },
            onError: (err) => {
                console.log("error", err)
                const message = err.response?.data?.message || "Send Invite Action Failed"
                toast.error(message)
            }
        })
    }

    const confirmCancelInvitation = () => {
        const inputData = {
            invitation_id: currentLocationInvitation?._id
        }
        cancelLocationInvitationMutation.mutate(inputData, {
            onSuccess: () => {
                setShowCancelInviteModal(false);
                toast.success("Invitation cancelled successfully");
                queryClient.invalidateQueries(['invitation_list']); // Adjust key if needed
            },
            onError: (err) => {
                const message = err.response?.data?.message || "Failed to cancel invitation";
                toast.error(message);
            },
        });
        setShowDeleteCamModal(false);
    }

    const handleCancelInvitation = (invitation) => {
        setCurrentLocationInvitation(invitation);
        setShowCancelInviteModal(true);
    };

    const handleLocationSendInviteBulk = () => {
        if (!canSubmit()) return;
        if (!bulkInviteFile) {
            toast.error("Excel file must be required")
            resetSubmit();
            return
        }
        const locationBulkInviteFormData = new FormData();
        locationBulkInviteFormData.append('invitation_xlsx', bulkInviteFile)
        locationBulkInviteFormData.append('location_id', _id)

        addNewLocationBulkInvitationMutation.mutate(locationBulkInviteFormData, {
            onSuccess: () => {
                resetStates();
                resetSubmit();
                setShowLocationSendBulkInviteModal(false)
                toast.success("Inviation Sent Successfully")
                queryClient.invalidateQueries({ queryKey: ['invitation_list'] });
            },
            onError: (err) => {
                console.log("error", err)
                const message = err.response?.data?.message || "Send Bulk Invite Action Failed"
                toast.error(message)
            }
        })
    }

    const playStream = (stream_url) => {
        setPlaybackStreamURL(stream_url)
        setShowPlayStreamModal(true)
    }

    const renderTabContent = () => {
        switch (activeTab) {
            case 'Invited Tenant':
                return (
                    <div className="space-y-4">
                        <div className="flex justify-between items-center mb-6">
                            <div className="relative flex-1 w-full">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchInviteTerm}
                                    onChange={(e) => setSearchInviteTerm(e.target.value)}
                                    className={`${isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"} w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                                />
                            </div>
                            <button
                                onClick={() => setShowLocationSendBulkInviteModal(true)}
                                className="ml-4 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium">
                                Send Bulk Invite
                            </button>
                            <button
                                onClick={() => setShowLocationSendInviteModal(true)}
                                className="ml-4 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium">
                                Send Invite
                            </button>
                        </div>
                        {invitedTenants?.length > 0 ?
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {invitedTenants.filter((invite) =>
                                    invite.name.toLowerCase().includes(searchInviteTerm.toLowerCase()) ||
                                    invite.email.toLowerCase().includes(searchInviteTerm.toLowerCase())
                                ).map((tenant) => (
                                    <div key={tenant.id} className={`${isDarkMode ? "bg-gray-900" : "bg-white"} rounded-lg p-4 border border-gray-200`}>
                                        <div className="flex items-start justify-between">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                                                    <Users className="w-5 h-5 text-white" />
                                                </div>
                                                <div>
                                                    <h3 className={`font-medium ${isDarkMode ? "text-white" : "text-gray-900"}`}>{tenant.name}</h3>
                                                    <div className="flex items-center space-x-2 mt-1">
                                                        <Mail className={`w-4 h-4 ${isDarkMode ? "text-white" : "text-gray-900"}`} />
                                                        <span className={`text-sm ${isDarkMode ? "text-white" : "text-gray-900"}`}>{tenant.email}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => handleCancelInvitation(tenant)}
                                                className="text-red-500 hover:text-red-700 transition-colors">
                                                <Trash2 className="w-5 h-5" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className={`w-[100%] text-center py-16 ${isDarkMode ? "bg-[rgba(0,0,0,0.5)]" : "bg-[rgba(255,255,255,1)]"}`}>
                                <div className="flex justify-center items-center pt-8 mb-8">
                                    <img
                                        alt={"nodata"}
                                        className='w-[250px]'
                                        src={noData} />
                                </div>
                                <p className={`text-2xl ${isDarkMode ? "text-white" : "text-gray-800"} text-center`}>NO INVITATION FOUND</p>
                                <div className='w-full flex items-center justify-center py-3'>
                                    <button
                                        onClick={() => setShowLocationSendInviteModal(true)}
                                        className={` justify-center py-2 w-[200px] rounded-full border text-center ${isDarkMode ? "border-white text-white" : "border-blue-600 text-blue-600"} flex items-center mt-8`}>
                                        <Plus size={18} className="mr-1" />
                                        Send Invite
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                );

            case 'Streams':
                return (
                    <div className="space-y-6">
                        {connectedCameras?.length > 0 ?
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                                {connectedCameras.filter((camera) =>
                                    camera.name.toLowerCase().includes(searchCameraTerm.toLowerCase())
                                ).map((camera) => (
                                    <div key={camera._id} className="bg-white border border-gray-200 overflow-hidden shadow-sm">
                                        <span
                                            className="font-medium text-gray-900"
                                            style={{
                                                position: "absolute",
                                                zIndex: 999,
                                                margin: '10px',
                                                padding: '5px',
                                                backgroundColor: 'rgba(255,255,255,0.5)',
                                            }}>
                                            {camera?.name}
                                        </span>
                                        <div className="relative">
                                            <HLSPlayer
                                                method={playStream}
                                                src={camera?.stream_url}
                                                sx={{}}
                                                controls={false}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className={`w-[100%] text-center py-16 ${isDarkMode ? "bg-[rgba(0,0,0,0.5)]" : "bg-[rgba(255,255,255,1)]"}`}>
                                <div className="flex justify-center items-center pt-8 mb-8">
                                    <img
                                        alt={"nodata"}
                                        className='w-[250px]'
                                        src={noData} />
                                </div>
                                <p className={`text-2xl ${isDarkMode ? "text-white" : "text-gray-800"} text-center`}>NO ACTIVE STREAM</p>
                            </div>
                        }
                    </div>
                );

            case 'Recordings':
                return (
                    <>
                        {isRecordingCamSelected ?
                            <>
                                <div className="space-y-4">
                                    <div className="flex justify-between items-center mb-6">
                                        <div className="relative flex-1 w-full">
                                            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                value={searchRecordingTagTerms}
                                                onChange={(e) => setSearchRecordingTagTerms(e.target.value)}
                                                className={`${isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"} w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                                            />
                                        </div>
                                        <DatePicker
                                            selected={recordingDate ? moment(recordingDate).toLocaleString() : moment().toLocaleString()}
                                            onChange={(d) => {setRecordingPage(1); setRecordingDate(d.toDateString() || "")}}
                                            maxDate={new Date()}
                                            placeholderText="Select Recording Date"
                                            className="w-[265px] px-4 ml-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            style={{
                                                backgroundColor: colors.inputBackground,
                                                borderColor: colors.border,
                                                color: colors.text
                                            }}
                                            dateFormat="dd-MM-yyyy"
                                        />
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    <button
                                        onClick={() => setIsRecordingCamSelected(null)}
                                        className="bg-blue-600 text-white px-4 py-1 rounded-lg hover:bg-blue-700 transition-colors font-medium">
                                        Back to Recording List
                                    </button>
                                    {selectedCamRecordings?.length > 0 ?
                                        <>
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                {selectedCamRecordings?.map((recording) => (
                                                    <div className='bg-[#eee] pb-1' style={{ borderRadius: 10 }}>
                                                        <video
                                                            key={recording?._id}
                                                            controls
                                                            style={{ height: "210px", width: "100%" }}>
                                                            <source
                                                                src={`${REACT_APP_STEAM_DISTRIBUTION}/${recording?.s3Path}`}
                                                            />
                                                        </video>
                                                        <p className='p-2'>Date: {recording?.recordingDate??""}<br />
                                                            Start Time : {recording?.recordingStartTime??""}<br />
                                                            End Time : {recording?.recordingEndTime??""}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                            <Pagination
                                                showSizeChanger={false}
                                                // onShowSizeChange={(e) => setRecordingLimit(e)}
                                                defaultCurrent={recordingPage}
                                                total={recordingTotalPages}
                                                onChange={(e) => setRecordingPage(e)}
                                            />
                                        </>
                                        :
                                        <div className={`w-[100%] text-center py-16 ${isDarkMode ? "bg-[rgba(0,0,0,0.5)]" : "bg-[rgba(255,255,255,1)]"}`}>
                                            <div className="flex justify-center items-center pt-8 mb-8">
                                                <img
                                                    alt={"nodata"}
                                                    className='w-[250px]'
                                                    src={noData} />
                                            </div>
                                            <p className={`text-2xl ${isDarkMode ? "text-white" : "text-gray-800"} text-center`}>NO RECORDINGS AVAILABLE FOR SELECTED DATE</p>
                                        </div>
                                    }
                                </div>
                            </>
                            :
                            <>
                                <div className="space-y-4">
                                    <div className="flex justify-between items-center mb-6">
                                        <div className="relative flex-1 w-full">
                                            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                value={searchCameraTerm}
                                                onChange={(e) => setSearchCameraTerm(e.target.value)}
                                                className={`${isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"} w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    {connectedCameras?.length > 0 ?
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                            {connectedCameras.filter((camera) =>
                                                camera.name.toLowerCase().includes(searchCameraTerm.toLowerCase()) ||
                                                camera.url.toLowerCase().includes(searchCameraTerm.toLowerCase())
                                            ).map((camera) => (
                                                <div
                                                    key={camera.id}
                                                    className={`${isDarkMode ? "bg-gray-900" : "bg-white"} rounded-lg p-4 border border-gray-200 cursor-pointer`}
                                                    onClick={() => setIsRecordingCamSelected(camera)}>
                                                    <div className="flex items-start justify-between">
                                                        <div className="flex items-center space-x-3">
                                                            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                                                                <Camera className="w-5 h-5 text-white" />
                                                            </div>
                                                            <div>
                                                                <h3 className={`font-medium ${isDarkMode ? "text-white" : "text-gray-900"} `} >{camera.name}</h3>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <button
                                                                onClick={() => setIsRecordingCamSelected(camera)}
                                                                className="text-red-500 hover:text-red-700 transition-colors">
                                                                <Video className=" h-25 mr-2" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        <div className={`w-[100%] text-center py-16 ${isDarkMode ? "bg-[rgba(0,0,0,0.5)]" : "bg-[rgba(255,255,255,1)]"}`}>
                                            <div className="flex justify-center items-center pt-8 mb-8">
                                                <img
                                                    alt={"nodata"}
                                                    className='w-[250px]'
                                                    src={noData} />
                                            </div>
                                            <p className={`text-2xl ${isDarkMode ? "text-white" : "text-gray-800"} text-center`}>NO CAMERA CONNECTED</p>
                                        </div>
                                    }
                                </div>
                            </>
                        }
                    </>
                );

            case 'Connected Cameras':
                return (
                    <div className="space-y-4">
                        <div className="flex justify-between items-center mb-6">
                            <div className="relative flex-1 w-full">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchCameraTerm}
                                    onChange={(e) => setSearchCameraTerm(e.target.value)}
                                    className={`${isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"} w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                                />
                            </div>
                            <button
                                onClick={() => setShowLocationAddCamModal(true)}
                                className="ml-4 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium">
                                Add Camera
                            </button>
                        </div>
                        {connectedCameras?.length > 0 ?
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {connectedCameras.filter((camera) =>
                                    camera.name.toLowerCase().includes(searchCameraTerm.toLowerCase()) ||
                                    camera.url.toLowerCase().includes(searchCameraTerm.toLowerCase())
                                ).map((camera) => (
                                    <div key={camera.id} className={`${isDarkMode ? "bg-gray-900" : "bg-white"} rounded-lg p-4 border border-gray-200`}>
                                        <div className="flex items-start justify-between">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                                                    <Camera className="w-5 h-5 text-white" />
                                                </div>
                                                <div>
                                                    <h3 className={`font-medium ${isDarkMode ? "text-white" : "text-gray-900"} `} >{camera.name}</h3>
                                                </div>
                                            </div>
                                            <div>
                                                <button
                                                    onClick={() => handleEditCamera(camera)}
                                                    className="text-red-500 hover:text-red-700 transition-colors">
                                                    <PencilIcon className="w-5 h-5 mr-2" />
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteCamera(camera)}
                                                    className="text-red-500 hover:text-red-700 transition-colors">
                                                    <Trash2 className="w-5 h-5" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className={`w-[100%] text-center py-16 ${isDarkMode ? "bg-[rgba(0,0,0,0.5)]" : "bg-[rgba(255,255,255,1)]"}`}>
                                <div className="flex justify-center items-center pt-8 mb-8">
                                    <img
                                        alt={"nodata"}
                                        className='w-[250px]'
                                        src={noData} />
                                </div>
                                <p className={`text-2xl ${isDarkMode ? "text-white" : "text-gray-800"} text-center`}>NO CAMERA ADDED</p>
                                <div className='w-full flex items-center justify-center py-3'>
                                    <button
                                        onClick={() => setShowLocationAddCamModal(true)}
                                        className={` justify-center py-2 w-[200px] rounded-full border text-center ${isDarkMode ? "border-white text-white" : "border-blue-600 text-blue-600"} flex items-center mt-8`}>
                                        <Plus size={18} className="mr-1" />
                                        Add Camera
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                );

            default:
                return null;
        }
    };

    const handleExcelChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setBulkInviteFile(file)
        }
    };

    // Location Data
    useEffect(() => {
        if (isLocationSuccess) {
            setLocationData(locationResponse?.data?.data)
        }
    }, [locationResponse, isLocationSuccess])

    // Camera
    useEffect(() => {
        if (isconnectedCamerasSuccess) {
            setConnectedCameras(connectedCamerasResponse?.data?.data?.result)
        }
    }, [isconnectedCamerasSuccess, connectedCamerasResponse])

    // invitations
    useEffect(() => {
        if (isInvitationSuccess) {
            setInvitedTenants(invitationResponse?.data?.data?.result)
        }
    }, [invitationResponse, isInvitationSuccess])

    return (
        <>
            <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-white"}`}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    {/* Header */}
                    <div className="mb-8">
                        <div className="flex mb-6">
                            <button onClick={() => navigate(-1)} className="mr-4 p-2 border rounded-lg transition-colors">
                                <ChevronLeft className={`w-6 h-6 ${isDarkMode ? "text-white" : "text-gray-600"} `} />
                            </button>
                            <p
                                className={`w-full text-3xl poppins-regular ${isDarkMode ? "text-white" : "text-gray-900"} mt-1`}
                                style={{ textAlign: "center" }}>LOCATION DETAILS
                            </p>
                        </div>
                        {/* Location Info Card */}
                        <div className={` ${isDarkMode ? "bg-gray-900 border-gray-500" : "bg-white border-gray-200"} rounded-lg shadow-sm border-2 p-6`}>
                            <div className="flex items-start space-x-6">
                                {/* Location Image */}
                                <div className="w-32 h-24 rounded-lg relative overflow-hidden">
                                    <div className="absolute inset-0">
                                        <div className="w-full h-full">
                                            <img src={locationData?.media ? `${REACT_APP_IMAGE_URL}/${locationData?.media}` : eventIcon} alt={locationData?.name} />
                                        </div>
                                    </div>
                                </div>
                                {/* Location Details Grid */}
                                <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-6">
                                    <div className="space-y-4">
                                        <div className="flex items-center space-x-3 space-y-2">
                                            <Users className="w-5 h-5 text-blue-500" />
                                            <span className={`${isDarkMode ? "text-white" : "text-gray-600"}`}>{locationData?.name}</span>
                                        </div>
                                        <div className="flex items-center space-x-3 space-y-3">
                                            <Users className="w-5 h-5 mt-3 text-blue-500" />
                                            <span className={`${isDarkMode ? "text-white" : "text-gray-600"}`}>No Limit</span>
                                        </div>
                                    </div>
                                    <div className="space-y-4">
                                        <div className="flex items-center space-x-3 space-y-2">
                                            <Lock className="w-5 h-5 text-blue-500" />
                                            <span className={`${isDarkMode ? "text-white" : "text-gray-600"}`}>
                                                {locationData?.payment_status == 2 ? locationData?.access_code : "******"}
                                            </span>
                                        </div>
                                        <div className="flex items-center space-x-3 space-y-3">
                                            <MapPin className="w-5 h-5 mt-3 text-blue-500" />
                                            <span className={`${isDarkMode ? "text-white" : "text-gray-600"}`}>{locationData?.location?.name}</span>
                                        </div>
                                    </div>
                                    <div className="space-y-4">
                                        <div className="flex items-center space-x-3 space-y-3">
                                            <Camera className="w-5 h-5 mt-3 text-blue-500" />
                                            <span className={`${isDarkMode ? "text-white" : "text-gray-600"}`}>{locationData?.camera_limit} Cameras</span>
                                        </div>
                                        <div className="flex items-center space-x-3 space-y-3">
                                            <Clock className="w-5 h-5 mt-3 text-blue-500" />
                                            <span className={`${isDarkMode ? "text-white" : "text-gray-600"}`}>{locationData?.duration} months</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Tabs */}
                    <div className="mb-8">
                        <div className={`flex space-x-1 ${isDarkMode ? "bg-gray-900 border-gray-500" : "bg-white border-gray-100"} border-2 p-1 rounded-lg w-full`}>
                            {['Invited Tenant', 'Streams', 'Recordings', 'Connected Cameras'].map((tab) => (
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`w-full px-6 py-3 rounded-lg poppins-regular transition-all ${activeTab === tab
                                        ? 'bg-blue-600 text-white shadow-sm'
                                        : `${isDarkMode ? "text-white" : "text-gray-800"} hover:text-gray-900 hover:bg-gray-200`
                                        }`}>
                                    {tab}
                                </button>
                            ))}
                        </div>
                    </div>
                    {/* Tab Content */}
                    <div className={`${isDarkMode ? "bg-gray-900" : "bg-white"} rounded-lg shadow-sm border border-gray-200 p-6`}>
                        {renderTabContent()}
                    </div>
                </div>
            </div>
            {/* Add Location Camera Modal */}
            <Modal isDarkMode={isDarkMode} key={"addlocationcamform"} title="ADD CAMERA" isOpen={showLocationAddCamModal} onClose={() => setShowLocationAddCamModal(false)}>
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>Name</label>
                    <input
                        type="text"
                        value={locationCamName}
                        placeholder="Name"
                        className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setLocationCamName(e.target.value)}
                        style={{
                            backgroundColor: colors.inputBackground,
                            borderColor: colors.border,
                            color: colors.text
                        }}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>URL</label>
                    <input
                        type="text"
                        value={locationCamUrl}
                        placeholder="URL"
                        className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setLocationCamUrl(e.target.value)}
                        style={{
                            backgroundColor: colors.inputBackground,
                            borderColor: colors.border,
                            color: colors.text
                        }}
                    />
                </div>
                <div className='text-center'>
                    <button
                        onClick={handleLocationAddCam}
                        disabled={addNewLocationCamMutation?.isLoading ? true : false}
                        className="w-[200px] py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition mt-4">
                        {addNewLocationCamMutation?.isLoading ? "Processing..." : "Add Now"}
                    </button>
                </div>
            </Modal>
            {/* Edit Location Camera Modal */}
            <Modal isDarkMode={isDarkMode} key={"editlocationcamform"} title="EDIT CAMERA" isOpen={showLocationEditCamModal} onClose={() => setShowLocationEditCamModal(false)}>
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>Name</label>
                    <input
                        type="text"
                        value={locationCamName}
                        placeholder="Name"
                        className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setLocationCamName(e.target.value)}
                        style={{
                            backgroundColor: colors.inputBackground,
                            borderColor: colors.border,
                            color: colors.text
                        }}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>URL</label>
                    <input
                        type="text"
                        value={locationCamUrl}
                        placeholder="URL"
                        className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setLocationCamUrl(e.target.value)}
                        style={{
                            backgroundColor: colors.inputBackground,
                            borderColor: colors.border,
                            color: colors.text
                        }}
                    />
                </div>
                <div className='text-center'>
                    <button
                        onClick={handleLocationEditCam}
                        disabled={editLocationCamMutation?.isLoading ? true : false}
                        className="w-[200px] py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition mt-4">
                        {editLocationCamMutation?.isLoading ? "Processing..." : "Update Now"}
                    </button>
                </div>
            </Modal>
            {/* Delete Location Camera Modal */}
            <Modal isDarkMode={isDarkMode} key={"deleteform"} title="DELETE CAMERA" isOpen={showDeleteCamModal} onClose={() => setShowDeleteCamModal(false)}>
                <div className="text-center mb-6">
                    <p className="mb-6" style={{ color: colors.text }}>Are you sure you want to delete this Camera?</p>
                    <div className='text-center mt-5'>
                        <button
                            onClick={() => setShowDeleteCamModal(false)}
                            className="w-[200px] py-3 text-center font-medium hover:bg-gray-100 dark:hover:bg-gray-800 transition rounded-full"
                            style={{ color: colors.text }}>
                            Cancel
                        </button>
                        <button
                            onClick={confirmDeleteCamera}
                            className="w-[200px] py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition mb-3 ml-3">
                            Delete
                        </button>
                    </div>
                </div>
            </Modal>
            {/* Send Location Invite Modal */}
            <Modal isDarkMode={isDarkMode} key={"sendlocationinviteform"} title="SEND INVITE" isOpen={showLocationSendInviteModal} onClose={() => setShowLocationSendInviteModal(false)}>
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>Name</label>
                    <input
                        type="text"
                        value={locationTenantName}
                        placeholder="Name"
                        className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setLocationTenantName(e.target.value)}
                        style={{
                            backgroundColor: colors.inputBackground,
                            borderColor: colors.border,
                            color: colors.text
                        }}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>Email</label>
                    <input
                        type="email"
                        value={locationTenantEmail}
                        placeholder="Email"
                        className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={(e) => setLocationTenantEmail(e.target.value)}
                        style={{
                            backgroundColor: colors.inputBackground,
                            borderColor: colors.border,
                            color: colors.text
                        }}
                    />
                </div>
                <div className='text-center'>
                    <button
                        onClick={handleLocationSendInvite}
                        disabled={addNewLocationInvitationMutation?.isLoading ? true : false}
                        className="w-[200px] py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition mt-4">
                        {addNewLocationInvitationMutation?.isLoading ? "Processing..." : "Send"}
                    </button>
                </div>
            </Modal>
            {/* Cancel Location Invite Modal */}
            <Modal isDarkMode={isDarkMode} key={"cancelinvite"} title="CANCEL INVITE" isOpen={showCancelInviteModal} onClose={() => setShowCancelInviteModal(false)}>
                <div className="text-center mb-6">
                    <p className="mb-6" style={{ color: colors.text }}>Are you sure you want to cancel this user invitation?</p>
                    <div className='text-center mt-5'>
                        <button
                            onClick={() => setShowCancelInviteModal(false)}
                            className="w-[200px] py-3 text-center font-medium transition rounded-full"
                            style={{ color: colors.text }}>
                            Cancel
                        </button>
                        <button
                            onClick={confirmCancelInvitation}
                            className="w-[200px] py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition mb-3 ml-3">
                            Confirm
                        </button>
                    </div>
                </div>
            </Modal>
            {/* Send Location Bulk Invite Modal */}
            <Modal isDarkMode={isDarkMode} key={"sendlocationbulkinviteform"} title="SEND BULK INVITE" isOpen={showLocationSendBulkInviteModal} onClose={() => setShowLocationSendBulkInviteModal(false)}>
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>Download Excel Format File</label>
                    <a
                        href={REACT_APP_EXCEL_FORMAT_LINK}
                        download={"ExcelFormat.xlsx"}>
                        <button
                            className="px-3 py-1 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 transition">
                            Download
                        </button>
                    </a>
                </div>
                <SingleSubmitForm onSubmit={handleLocationSendInviteBulk}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>Excel File</label>
                        <input
                            className={`${isDarkMode ? "text-white" : "text gray-900"}`}
                            type='file'
                            style={{ cursor: 'pointer' }}
                            onChange={handleExcelChange}
                        />
                    </div>
                    <div className='text-center'>
                        <button
                            type='submit'
                            disabled={addNewLocationBulkInvitationMutation?.isLoading ? true : false}
                            className="w-[200px] py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition mt-4">
                            {addNewLocationBulkInvitationMutation?.isLoading ? "Processing..." : "Upload Now"}
                        </button>
                    </div>
                </SingleSubmitForm>
            </Modal>
            {/* Play stream Modal */}
            <AntModal
                key={"playStreamModal"}
                title="STREAM PLAYER"
                className='w-md'
                centered
                width="auto"
                bodyStyle={{ padding: 0, background: '#000' }}
                wrapClassName="stream-modal-wrap"
                open={showPlayStreamModal}
                footer={null}
                onCancel={() => setShowPlayStreamModal(false)}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <HLSPlayer
                        src={playbackStreamURL}
                        sx={{ width: '968px' }}
                    />
                </div>
            </AntModal>
        </>
    );
};

export default LocationDetails;